import { GlBadge, GlIcon, GlLoadingIcon } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
export default {
    name: 'DuoSingleSelectOptions',
    components: {
        GlBadge,
        GlIcon,
        GlLoadingIcon
    },
    props: {
        options: {
            type: Array,
            required: true
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        },
        submittingId: {
            type: String,
            required: false,
            default: null
        },
        unchosen: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    emits: [
        'select'
    ]
};
